/**
 * Chart 域稳定常量与轻量映射。
 *
 * ## 为何 ConfigChartType 放在 constants.ts（而非 types.ts）
 *
 * `ConfigChartType` **不定义**合法 chart_type 集合，而是在 `ChartType` / `TChartType` 之上做
 * 「前端 chart_type 字符串 → 后端 customizeSetting storage key」的二段映射
 *（如 `LineChart` → `lineChart`）。
 *
 * 与 types.ts 的分工：
 * - types.ts 的 `ChartType`：领域原语，改成员 = 新增/删除一种图表类型
 * - 本文件的 `ConfigChartType`：存库/API 协议映射，改 value = 只改后端 key 写法
 *
 * 跨域（多维分析、报表 Dashboard 等）共用，故归 chart 域；大型配置表见 `@dbl/core/chartEditor`。
 */

import { ChartType } from './types';
import type { TChartType } from './types';

/**
 * 图表配置存储 / API 上传时使用的后端短类型名。
 * 读取路径：`chartsCfgSave[chartType].customizeSetting[ConfigChartType[chartType]]`。
 */

export const ConfigChartType = {
  [ChartType.Table]: 'table',
  [ChartType.Pie]: 'pieChart',
  [ChartType.Bar]: 'barChart',
  [ChartType.StackBar]: 'stackChart',
  [ChartType.Line]: 'lineChart',
  [ChartType.EventLine]: 'eventLineChart',
  [ChartType.BigNumber]: 'bigNumberChart',
  [ChartType.Trend]: 'trendChart',
  [ChartType.MixedChart]: 'mixedChart',
  [ChartType.DimNumberTrend]: 'dimTrend',
  [ChartType.Map]: 'map',
  [ChartType.WordCloud]: 'wordCloud',
  [ChartType.HorizontalBarChart]: 'horizontalBarChart',
  [ChartType.PercentStackBar]: 'percentStackBarChart',
  [ChartType.PercentLine]: 'percentLineChart',
} as const satisfies Record<TChartType, string>;

export type TConfigChartType =
  (typeof ConfigChartType)[keyof typeof ConfigChartType];
